import React, {useState} from "react";
import {observer} from "mobx-react";
import {TextField} from "@mui/material";
import Utility from "../../Utility";
import * as serverEnums from "../../serverClientShared/sharedEnums";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const CreateRenameModal = observer(() => {
    const {modalStore, generalStore} = useStores();
    const [email, setEmail] = useState('');

    const isEmailValid = Utility.verifyEmail(email);


    function closeModal() {
        modalStore.isChangeEmailDialogOpen = false;
        modalStore.resetModalData();
    }

    async function changeEmail() {
        if (!isEmailValid) {
            return;
        }
        generalStore.isLoaderOpen = true;
        try {
            const status = await generalStore.changeEmail(email);
            if (status === serverEnums.responseEnum.OK) {
                await generalStore.refreshCurrentUser();
                generalStore.isLoaderOpen = false;
                modalStore.showSuccessMessage(`${generalStore.translate('verificationSentSentence1_beforeEmail')} ${email}${generalStore.translate('verificationSentSentence2_afterEmail')}`);
                closeModal();
            } else {
                generalStore.isLoaderOpen = false;
                modalStore.showErrorMessage(generalStore.translate('problemChangingEmail'));
            }
        } catch (e) {
            console.error(e);
            generalStore.isLoaderOpen = false;
            modalStore.showErrorMessage(generalStore.translate('problemChangingEmail'));
        }
    }

    return (
        <GeneralDialog
            openControl='isChangeEmailDialogOpen'
            className='blue-dialog'
            title={generalStore.translate('changeEmail')}
            body={
                <React.Fragment>
                    <span className="dialog-description">{generalStore.translate('setNewEmail')}</span>
                    <TextField
                        autoFocus
                        placeholder={generalStore.translate('enterNewEmail') + '...'}
                        value={email}
                        className='name-input wide'
                        onChange={e => setEmail(e.target.value)}
                        variant="filled"
                    />
                </React.Fragment>
            }
            isConfirmDisabled={!isEmailValid}
            onConfirm={changeEmail}
            confirmText={generalStore.translate('change')}
        />
    );
});

export default CreateRenameModal;
